// Requested weapon slot (InputCmd.weapon_slot): 0 primary, 1 secondary, 2 melee.

export const SLOT_COUNT = 3;

export class SlotSelector {
  /** Slot requested in every input command. */
  requested = 0;
  /** Slot that was requested before the current one ("last weapon"). */
  previous = 1;

  /** Request `slot`; a request for the current slot changes nothing. */
  select(slot: number): void {
    if (slot < 0 || slot >= SLOT_COUNT || slot === this.requested) return;
    this.previous = this.requested;
    this.requested = slot;
  }

  next(): void {
    this.select((this.requested + 1) % SLOT_COUNT);
  }

  prev(): void {
    this.select((this.requested + SLOT_COUNT - 1) % SLOT_COUNT);
  }

  last(): void {
    this.select(this.previous);
  }

  /** After a (re)spawn the sim starts on the primary slot. */
  reset(slot = 0): void {
    this.requested = slot;
    this.previous = slot === 1 ? 0 : 1;
  }
}
